export const STATUS_OPTION = [
  { value: '', text: 'Select Status', disabled: true },
  { value: 'applicant', text: 'Applicant', disabled: false },
  { value: 'current resident', text: 'Current Resident', disabled: false },
  { value: 'prior resident', text: 'Prior Resident', disabled: false },
];
